import moment from "moment-timezone";

export function isLessonPast(lesson, timeZone) {
  if (!lesson || lesson.eventType === "personal") {
    return false;
  }

  const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const now = moment().tz(tz);

  if (lesson.endDateDate) {
    return moment(lesson.endDateDate).tz(tz).isSameOrBefore(now);
  }

  if (!lesson.dateDate || !lesson.timeSlot) {
    return false;
  }

  const endPart = lesson.timeSlot.split(/\s*-\s*/)[1]?.trim();
  if (!endPart) {
    return false;
  }

  const dateStr = moment(lesson.dateDate).tz(tz).format("YYYY-MM-DD");
  const lessonEnd = moment.tz(`${dateStr} ${endPart}`, "YYYY-MM-DD HH:mm", tz);
  return lessonEnd.isValid() && lessonEnd.isSameOrBefore(now);
}
